module.exports = __webpack_public_path__ + "img/ms.be07a146.svg";